import { lang } from '../lang.js';
import { utils } from '../utils.js';
import { settings } from '../settings.js';
import { modes } from '../modes.js';


const create = () => {
    ruler.line = game.add.line(0, 0, 0, 100, 0, 100, 0xff0000)
        .setStrokeStyle(3, 0xff0000)
        .setOrigin(0)
        .setDepth(1)
        .myIgnore('top');

    ruler.line.myActive = false;

    ruler.legend = game.add.text(0, 0, '', utils.myFont(25, '#F00'))
        .setOrigin(0.5, 1).setDepth(1).myIgnore('top');
};

const show = ({x, y}) => {

    ruler.line.myActive = true;
    ruler.line.startX = x;
    ruler.line.startY = y;
    ruler.line.setAlpha(1);

    ruler.legend
        .setFontSize(Math.floor(30 / game.cameras.main.zoom))
        .setRotation(-game.cameras.main.rotation)
        .setAlpha(1);
};

const getDisplayText = ({x, y}) => {

    const showInInches = settings.preferences.units === 'inch';

    const rawDistance = Math.sqrt(
        ((ruler.line.startX - x) ** 2) + ((ruler.line.startY - y) ** 2)
    );

    const _distance = rawDistance * settings.diameter * 0.00263;

    const scaledDistance = showInInches ?
        _distance / 2.54:
        _distance;

    const displayUnits = showInInches ?
        lang.get('ruler inches unit', '"'):
        lang.get('ruler cm units', 'cm');

    return scaledDistance.toFixed(2) + displayUnits;
};

const hide = () => {
    if (ruler.line) {
        ruler.line.setAlpha(0);
        ruler.legend.setAlpha(0);
        ruler.line.myActive = false;
    }
};

const update = () => {
    if (!game.input.activePointer.isDown) {
        ruler.hide();
        modes.start('ruler');
        return;
    }

    const myPoint = utils.returnPoint(game.input.activePointer.position.x, game.input.activePointer.position.y)

    // first time ruler is clicked
    if (!ruler.line) ruler.create();

    // each time ruler is clicked
    if (!ruler.line.myActive) ruler.show(myPoint);

    // set line position
    ruler.line.setTo(ruler.line.startX, ruler.line.startY, myPoint.x, myPoint.y);

    // calculate legend text
    const rulerDisplayText = ruler.getDisplayText(myPoint);

    // set legend text and position
    ruler.legend
        .setText(rulerDisplayText)
        .setX(myPoint.x)
        .setY(myPoint.y);
};

export const ruler = {create, show, getDisplayText, hide, update};